import { Input, type InputProps } from "antd";
import styles from "./InputPhone.module.scss";
import { formatPhoneNumberWithExt } from "utils/helpers.salesEnablement";

type Props = Readonly<
  Omit<InputProps, "onChange"> & {
    value?: string;
    onChange?: (value: string) => void;
  }
>;

function InputPhone({ value, onChange, ...rest }: Props) {
  if (!onChange) throw new Error("onChange is required");

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["Tab", "Backspace", "Delete", "Enter"].includes(e.key) || e.metaKey) {
      return;
    }
    const sanitizedValue = value?.replace?.(/\D/g, "");
    if (sanitizedValue?.length === 33) {
      e.preventDefault();
    }
  };

  return (
    <Input
      className={styles.removeHandlers}
      value={value}
      onChange={value => {
        onChange(formatPhoneNumberWithExt(value.target.value));
      }}
      {...rest}
      style={{ width: "100%" }}
      onKeyDown={onKeyDown}
    />
  );
}
export default InputPhone;
